import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        vuex_windowWidth: window.innerWidth,
    },
    mutations: {
        setWindowWidth(state, width){
            state.vuex_windowWidth = width
        },
    }
})